module.exports = __webpack_public_path__ + "img/20190610161548279.fada86bf.png";